import { coreGet, coreMutate } from "../../core-api/api-client";
import type { GmailMailbox } from "../../core-api/gmail";

export const mailboxRoles = {
  SALES: "销售",
  INFO: "Info",
  PROCUREMENT: "采购",
  FINANCE: "财务",
  SOURCING: "查货",
} as const;
export type MailboxRole = keyof typeof mailboxRoles;
export interface ManagedMailbox extends GmailMailbox {
  roleType: MailboxRole | null;
  note: string | null;
  disabledAt: string | null;
  deletedAt: string | null;
  authorizedAt: string | null;
  createdAt: string;
  lastSuccessfulSyncAt: string | null;
  lastRecoverySyncAt: string | null;
  lastSentAt?: string | null;
  historyCursor: string | null;
  configurationVersion: number;
}
export interface MailboxDirectory {
  items: ManagedMailbox[];
  capabilities: {
    manage: boolean;
    authorize: boolean;
    revoke: boolean;
    sync: boolean;
  };
}
export const loadMailboxes = (signal?: AbortSignal) =>
  coreGet<MailboxDirectory>("/mailboxes", signal);
export const createMailbox = (input: {
  emailAddress: string;
  roleType: MailboxRole;
  note: string;
}) =>
  coreMutate<ManagedMailbox>("/mailboxes", "POST", {
    ...input,
    provider: "GMAIL",
  });
export const editMailbox = (
  mailbox: ManagedMailbox,
  roleType: MailboxRole,
  note: string,
) =>
  coreMutate<ManagedMailbox>(
    `/mailboxes/${mailbox.id}/configuration`,
    "PATCH",
    { roleType, note, expectedVersion: mailbox.configurationVersion },
  );
export const setMailboxEnabled = (mailbox: ManagedMailbox, enabled: boolean) =>
  coreMutate<ManagedMailbox>(`/mailboxes/${mailbox.id}/status`, "POST", {
    enabled,
    expectedVersion: mailbox.configurationVersion,
  });
export const deleteMailbox = (mailbox: ManagedMailbox) =>
  coreMutate<ManagedMailbox>(`/mailboxes/${mailbox.id}`, "DELETE", {
    expectedVersion: mailbox.configurationVersion,
  });
export const syncMailbox = (mailbox: ManagedMailbox) =>
  coreMutate(
    `/mailboxes/${mailbox.id}/sync/${!mailbox.historyCursor ? "initial" : mailbox.syncStatus === "RECOVERY_REQUIRED" ? "recovery" : "incremental"}`,
    "POST",
    {},
  );
